const ITEMS = [
    "NomiConnekt",
    "Spice Route Expeditions",
    "GoNomikai",
    "Hotels & Hostels",
    "Travel & Tourism",
    "Digital Agencies",
    "Service Businesses",
];

const Row = ({ ariaHidden }) => (
    <div className="marquee-row" aria-hidden={ariaHidden || undefined}>
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center gap-10">
                <span className="font-heading text-lg font-medium tracking-tight text-white/40 transition-colors duration-300 hover:text-white/80 sm:text-xl">
                    {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#CF4242]/70" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <section
            className="relative overflow-hidden border-y border-white/10 bg-[#0B0A09]"
            data-testid="marquee-band"
            aria-label="Products and industries we build for"
        >
            <div className="mx-auto max-w-7xl px-6 pt-10 lg:px-8">
                <p className="text-center text-[11px] font-bold uppercase tracking-[0.3em] text-white/30">
                    Products shipped · Industries served
                </p>
            </div>
            <div className="marquee-mask overflow-hidden py-8">
                <div className="marquee">
                    <Row />
                    <Row ariaHidden />
                </div>
            </div>
        </section>
    );
}
